import React from 'react';
import { IconUIComponentProps, useIconStyle } from './Icon';

export default function RestritoIcon({
  color,
  size,
  style,
  className,
  noFill,
}: IconUIComponentProps) {
  const styles = useIconStyle({ noFill });
  return (
    <svg
      className={[styles.icon, className].join(' ').trim()}
      color={color}
      fontSize={size}
      style={style}
      viewBox='0 0 20 20'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0ZM10 1C5.02944 1 1 5.02944 1 10C1 14.9706 5.02944 19 10 19C14.9706 19 19 14.9706 19 10C19 5.02944 14.9706 1 10 1ZM15.5 10C15.5 9.72386 15.2761 9.5 15 9.5H5L4.91012 9.50806C4.67688 9.55039 4.5 9.75454 4.5 10C4.5 10.2761 4.72386 10.5 5 10.5H15L15.0899 10.4919C15.3231 10.4496 15.5 10.2455 15.5 10Z'
      />
    </svg>
  );
}
